var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "u8-container-default" }, [
    _vm.$slots.header
      ? _c(
          "div",
          { ref: "header", staticClass: "u8-container-default__header" },
          [_vm._t("header")],
          2
        )
      : _vm._e(),
    _c(
      "div",
      { ref: "body", staticClass: "u8-container-default__body" },
      [_vm._t("default")],
      2
    ),
    _vm.$slots.footer
      ? _c(
          "div",
          { ref: "footer", staticClass: "u8-container-default__footer" },
          [_vm._t("footer")],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }